import React from 'react'
import img1 from '../svg/img-3.svg';
import img2 from '../svg/img-4.svg';
import img3 from '../svg/img-5.svg';
import img4 from '../svg/img-6.svg';
import img5 from '../svg/img-7.svg';

export default function Specs() {
  return (
    <>
      <section id="specs-bar" className="section-bg d-none d-lg-flex">
        <div className="container">
          <div className="row">
            <div className="specs col-12 row aos-init aos-animate" data-aos="fade-in">
              {/* <div className="sprites col-12 col-lg-2 d-flex align-items-center justify-content-center">
                <img src={img1} id="iso-logo" className="img-fluid" />
              </div>
              <div className="sprites col-12 col-lg-2 d-flex align-items-center justify-content-center">
                <img src={img2} id="exports-logo" className="img-fluid" />
              </div>
              <div className="sprites col-12 col-lg-2 d-flex align-items-center justify-content-center">
                <img src={img3} id="units-logo" className="img-fluid" />
              </div>
              <div className="sprites col-12 col-lg-2 d-flex align-items-center justify-content-center">
                <img src={img4} id="employees-logo" className="img-fluid" />
              </div>
              <div className="sprites col-12 col-lg-2 d-flex align-items-center justify-content-center">
                <img src={img5} id="machine-logo" className="img-fluid" />
              </div> */}
            </div>
          </div>
        </div>
      </section> 
    </>
  )
}
